if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      connectedCallback() {
        const productZoomModalIcons = document.querySelectorAll(
          ".product__media-icon"
        );

        if (!productZoomModalIcons) return;
        productZoomModalIcons.forEach((productZoomModalIcon) => {
          productZoomModalIcon.addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
              this.show(this);
            }
          });
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
            "data-media-id"
          )}"])`
        ).forEach((element) => {
          element.classList.remove("active");
        });
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`
        );

        if (!activeMedia) return;

        if (!modalFlkty) return;

        modalFlkty.cells.forEach((cell, index) => {
          const currentImg = cell.element.querySelector("img");
          if (currentImg == activeMedia) {
            modalFlkty.select(index);
          }
        });
      }
    }
  );
}
